import axios from "../../config/axiosConfig";
import {
  JOURNAL_VOUCHER_REPORT_REQUEST,
  JOURNAL_VOUCHER_REPORT_SUCCESS,
  JOURNAL_VOUCHER_REPORT_FAILURE
} from "../types/journal-voucher-report-types";

export const getJournalVoucherReport = (params, isMultyJV) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: JOURNAL_VOUCHER_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };
      console.log('params',params);
      
      const defaultParams2 = {
        filterType: params?.filterType || '',
        fromDate: params?.fromDate || '', 
        toDate: params?.toDate || '', 
        ...params
      };

      const requestParams = { ...defaultParams, ...defaultParams2 };
      // Construct the complete URL with query parameters
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/${isMultyJV ? 'journal-voucher-multy' : 'journal-voucher'}/getReport?${queryString}`;
      console.log('Complete API Request URL: ', fullUrl);

      return axios.get(fullUrl).then((response) => {
        console.log('API Response Data: ', response);
        if (response.data) {
          dispatch({ type: JOURNAL_VOUCHER_REPORT_SUCCESS, payload: response.data });
        }
        dispatch({ type: JOURNAL_VOUCHER_REPORT_FAILURE, error: null }); //temporary
      }).catch((error) => {
        console.error("Error fetching Journal Voucher Report:", error);
        dispatch({ type: JOURNAL_VOUCHER_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching Journal Voucher Report:", error);
      dispatch({ type: JOURNAL_VOUCHER_REPORT_FAILURE, error: error.message });
    }
  };
};

export const clearJournalVoucherReport = () => {
  return async (dispatch) => {
    dispatch({ type: JOURNAL_VOUCHER_REPORT_SUCCESS, payload: {} });
  }
}
